import { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { Thumbs } from "swiper/modules";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { addToCart } from "../../store/slices/cart-slice";
import { addToWishlist } from "../../store/slices/wishlist-slice";
import { addToCompare } from "../../store/slices/compare-slice";
import ReactStars from "react-rating-stars-component";
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  TwitterIcon,
  TelegramShareButton,
  TelegramIcon,
} from "react-share";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "react-inner-image-zoom/lib/styles.min.css";
import InnerImageZoom from "react-inner-image-zoom";
import { getCurrencyNameByCountry } from "../../helpers/countryHelper";

function ProductModal({ product, show, onHide, wishlistItem, compareItem }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  const { selectedCountry } = useSelector((state) => state.country);
  const cartItem = cartItems?.find((cartItem) => cartItem?.id == product?.id);
  const [quantityCount, setQuantityCount] = useState(1);
  const { t, i18n } = useTranslation();

  const currencyName = getCurrencyNameByCountry(selectedCountry);

  const onCloseModal = () => {
    setThumbsSwiper(null);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onCloseModal}
      className="product-quickview-modal-wrapper px-1"
    >
      <Modal.Header closeButton></Modal.Header>

      <div className="modal-body">
        <div className="row">
          <div className="col-md-5 col-sm-12 col-xs-12">
            <div
              className="product-large-image-wrapper position-sticky"
              style={{ top: "15px" }}
            >
              <Swiper
                thumbs={{ swiper: thumbsSwiper }}
                spaceBetween={10}
                loop={true}
                modules={[Thumbs]}
              >
                <SwiperSlide className="h-100">
                  <div className="single-image h-100">
                    <InnerImageZoom
                      src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                        product?.img
                      }`}
                      zoomSrc={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                        product?.img
                      }`}
                      zoomType="hover"
                      zoomScale={1.5}
                      fadeDuration="300"
                      fullscreenOnMobile={true}
                      className="img-fluid rounded-3 h-100"
                      loading="lazy"
                      alt="product thumb"
                      width={"100%"}
                      height={"100%"}
                    />
                  </div>
                </SwiperSlide>
                {product?.images?.map((img, i) => {
                  return (
                    <SwiperSlide
                      className="h-100"
                      style={{ cursor: "pointer", borderRadius: "5px" }}
                      key={i}
                    >
                      <div className="single-image h-100">
                        <InnerImageZoom
                          src={`${
                            import.meta.env.VITE_REACT_APP_API_URL
                          }/${img}`}
                          zoomType="hover"
                          zoomScale={1.5}
                          fadeDuration="300"
                          fullscreenOnMobile={true}
                          className="img-fluid rounded-3 h-100"
                          loading="lazy"
                          alt="product thumb"
                          width={"100%"}
                          height={"100%"}
                        />
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
            <div
              className="product-small-image-wrapper mt-15  position-sticky"
              style={{ top: "300px" }}
            >
              <Swiper
                onSwiper={setThumbsSwiper}
                spaceBetween={30}
                slidesPerView={4.5}
                touchRatio={0.2}
                freeMode={true}
                loop={true}
                breakpoints={{
                  1024: {
                    slidesPerView: 5,
                  },
                  700: {
                    slidesPerView: 4,
                  },
                  400: {
                    slidesPerView: 3,
                  },
                  0: {
                    slidesPerView: 3,
                  },
                }}
                slideToClickedSlide={true}
                navigation={true}
                modules={[Thumbs]}
              >
                <SwiperSlide style={{ cursor: "pointer", borderRadius: "5px" }}>
                  <img
                    src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                      product.img
                    }`}
                    alt="product thumb"
                    loading="lazy"
                    className="rounded-3 object-fit-cover"
                    style={{ height: "80px" }}
                    width={"75px"}
                  />
                </SwiperSlide>
                {product?.images?.length
                  ? product?.images?.map((img, i) => {
                      return (
                        <SwiperSlide
                          style={{ cursor: "pointer", borderRadius: "5px" }}
                          key={i}
                        >
                          <img
                            src={`${
                              import.meta.env.VITE_REACT_APP_API_URL
                            }/${img}`}
                            alt="product thumb"
                            style={{ height: "80px" }}
                            loading="lazy"
                            width={"75px"}
                            className="rounded-3 object-fit-cover"
                          />
                        </SwiperSlide>
                      );
                    })
                  : ""}
              </Swiper>
            </div>
          </div>
          <div className="col-md-7 col-sm-12 col-xs-12">
            <div className="product-details-content quickview-content">
              <Link to={`/product/${product?.id}`} className="mb-1">
                {" "}
                <h3>
                  {i18n?.language === "ar" ? product?.name : product?.name_en}
                </h3>
              </Link>
              <ReactStars
                count={5}
                value={product?.rating_avg}
                size={25}
                edit={false}
                activeColor="#ffd700"
                color="#e4e5e9"
              />
              <div className="product-details-price mt-1">
                {" "}
                {product?.discount ? (
                  <Fragment>
                    <span className="old">
                      {Number(product?.price)?.toFixed(2)} {currencyName}
                    </span>
                    <br />{" "}
                    <span>
                      {Number(
                        product?.price -
                          product?.price * (product?.discount / 100)
                      )?.toFixed(2)}{" "}
                      {currencyName}
                    </span>
                  </Fragment>
                ) : (
                  <span>
                    {Number(product?.price)?.toFixed(2)} {currencyName}
                  </span>
                )}
              </div>
              <div className="pro-details-list mb-3 pb-3">
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      i18n?.language === "ar"
                        ? product?.description
                        : product?.description_en,
                  }}
                ></p>
              </div>
              <div>
                <ul className="pro-details-quality m-0 mb-3">
                  <li>
                    <span>{t("stock")}</span> :{" "}
                    <b className="text-brand">{product?.quantity}</b>
                  </li>
                </ul>
              </div>
              <div className="pro-details-quality mt-0">
                <div className="cart-plus-minus">
                  <button
                    onClick={() =>
                      setQuantityCount(
                        quantityCount > 1 ? quantityCount - 1 : 1
                      )
                    }
                    className="dec qtybutton"
                  >
                    -
                  </button>
                  <input
                    className="cart-plus-minus-box"
                    type="text"
                    value={quantityCount}
                    readOnly
                  />
                  <button
                    onClick={() =>
                      setQuantityCount(
                        quantityCount < product?.quantity
                          ? quantityCount + 1
                          : quantityCount
                      )
                    }
                    className="inc qtybutton"
                  >
                    +
                  </button>
                </div>
                <div className="pro-details-cart btn-hover">
                  <button
                    className={`${cartItem ? "bg-primary" : ""}`}
                    onClick={() =>
                      dispatch(
                        addToCart({
                          product,
                          cartQuantity: quantityCount,
                        })
                      )
                    }
                    disabled={!product?.quantity || cartItem}
                  >
                    {" "}
                    {cartItem ? t("item_added_to_cart") : t("add_to_cart")}{" "}
                  </button>
                </div>
                <div className="pro-details-wishlist">
                  <button
                    className={wishlistItem !== undefined ? "active" : ""}
                    disabled={wishlistItem !== undefined}
                    title={
                      wishlistItem !== undefined
                        ? "Added to wishlist"
                        : "Add to wishlist"
                    }
                    onClick={() => dispatch(addToWishlist(product))}
                  >
                    <i className="pe-7s-like" />
                  </button>
                </div>
                <div className="pro-details-compare">
                  <button
                    className={compareItem !== undefined ? "active m-0" : "m-0"}
                    disabled={compareItem !== undefined}
                    title={
                      compareItem !== undefined
                        ? "Added to compare"
                        : "Add to compare"
                    }
                    onClick={() => dispatch(addToCompare(product))}
                  >
                    <i className="pe-7s-shuffle" />
                  </button>
                </div>
              </div>
              {product?.category ? (
                <div className="pro-details-meta">
                  <span>{t("category")} :</span>
                  <ul>
                    <li>
                      <Link to={`/category/${product?.category?.id}`}>
                        {i18n?.language === "ar"
                          ? product?.category?.name
                          : product?.category?.name_en}
                      </Link>
                    </li>
                  </ul>
                </div>
              ) : (
                ""
              )}
              <div className="d-flex align-items-center justify-content-start pro-details-meta">
                <span>{t("share_product")} :</span>
                <ul>
                  <li>
                    <FacebookShareButton
                      url={`${window.location.href}`}
                      quote={
                        i18n?.language === "ar"
                          ? product?.name
                          : product?.name_en
                      }
                    >
                      <FacebookIcon size={30} round />
                    </FacebookShareButton>
                  </li>

                  <li>
                    <WhatsappShareButton
                      url={`${window.location.href}`}
                      title={
                        i18n?.language === "ar"
                          ? product?.name
                          : product?.name_en
                      }
                      separator=" - "
                    >
                      <WhatsappIcon size={30} round />
                    </WhatsappShareButton>
                  </li>
                  <li>
                    <TwitterShareButton
                      url={`${window.location.href}`}
                      title={
                        i18n?.language === "ar"
                          ? product?.name
                          : product?.name_en
                      }
                    >
                      <TwitterIcon size={30} round />
                    </TwitterShareButton>
                  </li>
                  <li>
                    <TelegramShareButton
                      url={`${window.location.href}`}
                      title={
                        i18n?.language === "ar"
                          ? product?.name
                          : product?.name_en
                      }
                    >
                      <TelegramIcon size={30} round />
                    </TelegramShareButton>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ProductModal.propTypes = {
  currency: PropTypes.shape({}),
  discountedprice: PropTypes.number,
  finaldiscountedprice: PropTypes.number,
  finalproductprice: PropTypes.number,
  onHide: PropTypes.func,
  product: PropTypes.shape({}),
  show: PropTypes.bool,
  wishlistItem: PropTypes.shape({}),
  compareItem: PropTypes.shape({}),
};

export default ProductModal;
